export default __webpack_public_path__ + "static/media/headerPlanes.25737e38.png";